// extracted by mini-css-extract-plugin
module.exports = {"menuSubTitle":"UserGuideSidebar_menuSubTitle__2n76F","dropDownTitle":"UserGuideSidebar_dropDownTitle__2PT8n"};